import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { SvgIcon } from '@mui/material';
export const IconClose = memo((props) => {
    const { sx, ...rest } = props;
    return (_jsx(SvgIcon, { viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg', preserveAspectRatio: 'xMidYMid meet', ...rest, children: _jsx("path", { d: 'M14.3 12.179a.25.25 0 0 1 0-.354l9.263-9.262A1.5 1.5 0 0 0 21.439.442L12.177 9.7a.25.25 0 0 1-.354 0L2.561.442A1.5 1.5 0 0 0 .439 2.563L9.7 11.825a.25.25 0 0 1 0 .354L.439 21.442a1.5 1.5 0 0 0 2.122 2.121l9.262-9.263a.25.25 0 0 1 .354 0l9.262 9.263a1.5 1.5 0 0 0 2.122-2.121Z' }) }));
});
